/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'SnakeCaseToCamelCase',
  standalone: true
})
export class SnakeCaseToCamelCasePipe implements PipeTransform {
  transform(str: any): string {
    if (typeof str !== 'string')
      str = str.toString();

    return str
      .toLowerCase()
      .replace(/_(\w)/g, (_: any, match: any) => match.toUpperCase())
      .replace(/_/g, '');
  }
}
